import React, { useState, useEffect, useRef } from 'react';
import Editor from 'react-simple-wysiwyg';
import axios from 'axios';
import { UTILS } from '../../constants';
import { toast } from 'react-toastify';
import { getUserColor, getShortLetters } from '../../utils/function';
// import Select2 from 'react-select2-wrapper';
import Select from 'react-select';
// import 'select2/dist/css/select2.min.css';

export const DescEditor = ({ cardDetail, people_users }) => {
  //   console.log("cardDetail", cardDetail);
  const [html, setHtml] = useState('');
  const [dataEditorAdded, setDataEditorAdded] = useState('');
  const [dataAdded, setDataAdded] = useState('');
  const [showEditor, setShowEditor] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [people, setPeople] = useState([]);
  // const people = ['John Doe', 'Jane Smith', 'Alice Johnson', 'Bob Brown'];
  useEffect(() => {
    setPeople(people_users);
  }, []);

  const editorRef = useRef(null);
  useEffect(() => {
    setHtml(cardDetail?.description);
  }, [cardDetail]);

  const calculateCursorPosition = () => {
    if (!editorRef.current) return;

    const selection = window.getSelection();

    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0).cloneRange();
    const rect = range.getBoundingClientRect();
    const editorRect = editorRef.current.getBoundingClientRect();

    if (rect) {
      const editorStyle = window.getComputedStyle(editorRef.current);
      const editorPaddingLeft = parseFloat(editorStyle.paddingLeft);
      const editorPaddingTop = parseFloat(editorStyle.paddingTop);

      setDropdownPosition({
        top:
          rect.bottom - editorRect.top + window.scrollY - editorPaddingTop + 5,
        left: rect.left - editorRect.left + window.scrollX - editorPaddingLeft,
      });
    }
  };

  function onChange(e) {
    const updatedContent = e.target.value;

    setHtml(e.target.value);
    const atSymbolIndex = updatedContent.lastIndexOf('@');

    // If "@" is present and followed by valid characters (letters), show the dropdown
    if (
      atSymbolIndex !== -1 &&
      (atSymbolIndex === 0 ||
        /[\s]/.test(updatedContent.charAt(atSymbolIndex - 1))) && // Check for space or start
      /^[a-zA-Z]*$/.test(updatedContent.slice(atSymbolIndex + 1)) // Check that "@" is followed by letters
    ) {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      // Calculate cursor position
      const cursorPosition = {
        top: rect.top + window.scrollY, // Adjust for page scroll
        left: rect.left + window.scrollX, // Adjust for page scroll
      };
      setDropdownPosition([cursorPosition.top, cursorPosition.left]);
      // calculateCursorPosition();
      setShowDropdown(true);
      setSuggestions(people); // Populate dropdown with people suggestions
    } else {
      setShowDropdown(false); // Close dropdown if not tagging
    }
  }

  const handleSelectPerson = (person) => {
    const atSymbolIndex = html.lastIndexOf('@');

    const newContent =
      html.substring(0, atSymbolIndex) +
      `<span class="tag_user" contenteditable="false">@${person}</span>&nbsp;` +
      html.substring(atSymbolIndex + 1);

    setHtml(newContent);
    setShowDropdown(false);

    setTimeout(() => {
      const editor = editorRef.current;
      if (editor) {
        const range = document.createRange();
        const selection = window.getSelection();
        range.setStartAfter(editor.lastChild);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }, 0);
  };
  const handleSelectChange = (e) => {
    const selectedPerson = e.value;
    handleSelectPerson(selectedPerson);
  };
  let handleEditorChanges = async () => {
    // console.log('html', html);
    // setShowEditor(true);
    if (html == '') {
      toast.error('Please Insert Some Description');
    } else {
      const formData = new FormData();
      formData.append('task_id', cardDetail?.id); // Replace 'your_task_id' with the actual task_id
      formData.append('description', html);
      try {
        const response = await axios.post(
          `${UTILS.API_url}board/v1/board-list-cards/add-description`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
              'X-CSRF-TOKEN': 'SFy5sniSD26URDuLPmBAKy1C9KocZq9mXWFk0IWA',
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (response.status == 200) {
          // console.log("Response:", response?.data);
          setShowEditor(true);
          setDataAdded(response?.data?.description);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  let handleEditorEditChanges = async () => {
    // console.log('html', html);
    if (html == '') {
      toast.error('Please Insert Some Description');
      // alert('you need to do changes');
    } else {
      // setShowEditor(true);
      const formData = new FormData();
      formData.append('task_id', cardDetail?.id); // Replace 'your_task_id' with the actual task_id
      formData.append('description', html);
      try {
        const response = await axios.post(
          `${UTILS.API_url}board/v1/board-list-cards/description/update`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
              'X-CSRF-TOKEN': 'SFy5sniSD26URDuLPmBAKy1C9KocZq9mXWFk0IWA',
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (response.status == 200) {
          // console.log("Response:", response?.data);
          setShowEditor(true);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  return (
    <div className="tagSetDesc descArea">
      <div class="description-heading">
        <div className="d-flex align-items-center">
          <span class="material-symbols-outlined lg-icon">subject</span>
          Description
        </div>
        {/* {props.getDesc !== null ||
                      popData?.description !== null ? (
                        
                      ) : (
                        ""
                      )} */}
        {!cardDetail?.deleted_at &&
          (console.log('activities', cardDetail?.activities),
          (
            <>
                {cardDetail?.activities
                  ?.filter(
                    (act) =>
                      act.activity === 'Edit description to this card..' ||
                      act.activity === 'added description to this card.'
                  )
                  ?.sort((a, b) =>
                    a.activity === 'Edit description to this card..' ? -1 : 1
                  )
                  ?.slice(0, 1)
                  ?.map((activity) => (
                    <span key={activity.id}>{activity.created_at}</span>
                ))}
              <button
                onClick={() => setShowEditor((prev) => !prev)}
                className="btn btn-light att-add"
              >
                {cardDetail && cardDetail?.description !== null
                  ? 'Edit'
                  : 'Add'}
              </button>
            </>
          ))}
      </div>
      {showEditor ? (
        <div
          className="pd-one-padding position-relative"
          dangerouslySetInnerHTML={{ __html: html && html }}
        />
      ) : (
        <>
          {(cardDetail && cardDetail?.description !== null) ||
          dataAdded !== '' ? (
            <div className="pd-one-padding position-relative">
              <Editor ref={editorRef} value={html} onChange={onChange} />
              {/* {showDropdown && (
                <div
                  style={{
                    ...dropdownStyle,
                    top: dropdownPosition.top,
                    left: dropdownPosition.left,
                  }}
                  className="board-members-list member-assignment mentionList"
                >
                  {suggestions.map((person, index) => (
                    <div
                      key={index}
                      onClick={() => handleSelectPerson(person)}
                      style={dropdownItemStyle}
                      className="assign-unassign-members mentionLi"
                    >
                      <span className={`nameCir color${getUserColor(person)}`}>
                        {getShortLetters(person)}
                      </span>
                      <div className="membr-list-name">{person}</div>
                    </div>
                  ))}
                </div>
              )} */}
              {showDropdown && (
                <Select
                  options={suggestions.map((person) => ({
                    value: person,
                    label: person,
                  }))}
                  onChange={handleSelectChange}
                  style={{
                    position: 'absolute',
                    top: dropdownPosition.top,
                    left: dropdownPosition.left,
                    zIndex: 1000,
                    width: '200px',
                  }}
                  // options={{
                  //   placeholder: 'Select a person...',
                  //   noResultsText: 'No results found',
                  //   width: '100%',
                  // }}
                />
                // <Select2
                //   data={suggestions.map(person => ({ id: person, text: person }))}
                //   onSelect={handleSelectChange}
                //   style={{
                //     position: 'absolute',
                //     top: dropdownPosition.top,
                //     left: dropdownPosition.left,
                //     zIndex: 1000,
                //     width: '200px',
                //   }}
                //   options={{
                //     placeholder: 'Select a person...',
                //     noResultsText: 'No results found',
                //     width: '100%',
                //   }}
                // />
              )}
              <button
                className="mt-2 btn btn-light att-add"
                onClick={handleEditorEditChanges}
              >
                Save Description
              </button>
            </div>
          ) : (
            <div className="pd-one-padding position-relative">
              <Editor ref={editorRef} value={html} onChange={onChange} />
              {/* {showDropdown && (
                <div
                  style={{
                    ...dropdownStyle,
                    top: dropdownPosition.top,
                    left: dropdownPosition.left,
                  }}
                  className="board-members-list member-assignment mentionList"
                >
                  {suggestions.map((person, index) => (
                    <div
                      key={index}
                      onClick={() => handleSelectPerson(person)}
                      style={dropdownItemStyle}
                      className="assign-unassign-members mentionLi"
                    >
                      <span className={`nameCir color${getUserColor(person)}`}>
                        {getShortLetters(person)}
                      </span>
                      <div className="membr-list-name">{person}</div>
                    </div>
                  ))}
                </div>
              )} */}

              {showDropdown && (
                <Select
                  options={suggestions.map((person) => ({
                    value: person,
                    label: person,
                  }))}
                  onChange={handleSelectChange}
                  style={{
                    position: 'absolute',
                    top: dropdownPosition.top,
                    left: dropdownPosition.left,
                    zIndex: 1000,
                    width: '200px',
                  }}
                  // options={{
                  //   placeholder: 'Select a person...',
                  //   noResultsText: 'No results found',
                  //   width: '100%',
                  // }}
                />
                // <Select2
                //   data={suggestions.map(person => ({ id: person, text: person }))}
                //   onSelect={handleSelectChange}
                //   style={{
                //     position: 'absolute',
                //     top: dropdownPosition.top,
                //     left: dropdownPosition.left,
                //     zIndex: 1000,
                //     width: '200px',
                //   }}
                //   options={{
                //     placeholder: 'Select a person...',
                //     noResultsText: 'No results found',
                //     width: '100%',
                //   }}
                // />
              )}
              <button
                className="mt-2 btn btn-light att-add"
                onClick={handleEditorChanges}
              >
                Add Description
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
const dropdownStyle = {
  position: 'absolute',
  border: '1px solid #ddd',
  background: '#fff',
  zIndex: 1000,
  maxHeight: '150px',
  overflowY: 'auto',
  width: '200px',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
};

const dropdownItemStyle = {
  padding: '8px',
  cursor: 'pointer',
  borderBottom: '1px solid #eee',
};
